var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutopay = function SvgAutopay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9c3",
    d: "M7.8 13.7c-2.988 0-5.4-2.412-5.4-5.4s2.412-5.4 5.4-5.4a5.38 5.38 0 0 1 3.804 1.596L9 7.1h6v-6l-2.112 2.112C11.58 1.916 9.792 1.1 7.8 1.1 3.828 1.1.612 4.328.612 8.3s3.216 7.2 7.188 7.2a7.175 7.175 0 0 0 7.08-6h-1.824c-.552 2.4-2.688 4.2-5.256 4.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c3",
    fillRule: "evenodd",
    d: "M7.35 12.814v-.96c-1.12-.096-1.94-.522-2.517-1.11l.822-1.151c.394.416.97.79 1.696.917V8.825c-1.099-.277-2.294-.683-2.294-2.133 0-1.078.854-1.995 2.294-2.144v-.992h1.013v1.013c.864.096 1.59.427 2.165.95l-.842 1.109a3 3 0 0 0-1.323-.694v1.504c1.099.278 2.325.704 2.325 2.155 0 1.184-.768 2.09-2.325 2.25v.971zm1.803-3.05c0-.352-.33-.534-.789-.683v1.43c.523-.107.79-.417.79-.747m-2.549-3.2c0 .309.299.48.747.608V5.87c-.48.064-.747.33-.747.694"
  })));
};
export default SvgAutopay;